// extracted by mini-css-extract-plugin
export default {"currencyToggle":"CurrencyToggle_currencyToggle__CNuqN","currencyBtn":"CurrencyToggle_currencyBtn__uAAnQ","active":"CurrencyToggle_active__q-Zgo"};